<template>
	<div class="desc">
		<div class="top">
			<div class="top_wrap">
				<div class="top_nav_logo">
					<img :src="logoImg" />
				</div>
				<div class="top_nav_slogan">您身边的上网高速公路</div>
			</div>
		</div>
		<swiper
			class="swiper-container"
			:options="bodySwiperOption"
			@slideChange="onBodySwiperChange"
			ref="bodySwiper"
		>
			<swiperSlide class="swiper-slide">
				<div class="swiper-slide-1-wrap">
					<div class="body_title">
						<img :src="titleImg" />
					</div>
					<div class="body_desc">
						<p>
							<b>下载加速</b>
							<span></span>网课加速
							<span></span>视频加速
						</p>
						<p>
							<b>让下载速度飞起来</b>
						</p>
						<p>高清视频播放无卡顿</p>
					</div>
					<div class="body_btn_wrap">
						<a href="javascript:;" class="body_btn" @click="toIndex">立即体验</a>
					</div>
					<div class="body_tips_wrap" v-if="target_down > basic_down">
						您的带宽可从
						<span>{{basic_down/1024}}M</span>
						提升到
						<span>{{target_down/1024}}M</span>
					</div>
				</div>
			</swiperSlide>
			<swiperSlide>
				<div class="swiper-slide-3-wrap">
					<div class="body_title body_title_02">
						<img :src="title2Img" />
					</div>
					<div class="swiper-slide-3-nav">
						<div class="swiper-slide-3-nav-item swiper-slide-3-nav-item-01" data-index="0">
							<div class="swiper-slide-3-nav-item-wrap">
								<div class="swiper-slide-3-nav-item-icon">
									<img :src="navBg1Img" />
								</div>
								<div class="swiper-slide-3-nav-item-title">一键提速</div>
								<div class="swiper-slide-3-nav-item-desc">
									<p>最高支持提速700M</p>
									<p>中国电信和联通倾力打造</p>
								</div>
							</div>
						</div>
						<div class="swiper-slide-3-nav-item swiper-slide-3-nav-item-02" data-index="0">
							<div class="swiper-slide-3-nav-item-wrap">
								<div class="swiper-slide-3-nav-item-icon">
									<img :src="navBg2Img" />
								</div>
								<div class="swiper-slide-3-nav-item-title">全家共享</div>
								<div class="swiper-slide-3-nav-item-desc">
									<p>家庭内所有设备一起提速</p>
								</div>
							</div>
						</div>
						<div class="swiper-slide-3-nav-item swiper-slide-3-nav-item-03" data-index="0">
							<div class="swiper-slide-3-nav-item-wrap">
								<div class="swiper-slide-3-nav-item-icon">
									<img :src="navBg3Img" />
								</div>
								<div class="swiper-slide-3-nav-item-title">全新技术</div>
								<div class="swiper-slide-3-nav-item-desc">
									<p>带宽持续稳定提升</p>
								</div>
								<a href="javascript:;" class="body_btn" @click="toIndex">立即体验</a>
							</div>
						</div>
						<div class="swiper-slide-3-nav-item swiper-slide-3-nav-item-04" data-index="0">
							<div class="swiper-slide-3-nav-item-wrap">
								<div class="swiper-slide-3-nav-item-icon">
									<img :src="navBg4Img" />
								</div>
								<div class="swiper-slide-3-nav-item-title">智能终端</div>
								<div class="swiper-slide-3-nav-item-desc">
									<p>无需挂端 永久提速</p>
									<p>支持NAS、路由等多设备</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</swiperSlide>
		</swiper>
		<div class="swiper_page">
			<ul>
				<li :class="{'active':bodySwiperIndex==0?true: false}" @click="swiperTo(0)">
					<a href="javascript:;">全场景加速</a>
				</li>
				<li :class="{'active':bodySwiperIndex==1?true: false}" @click="swiperTo(1)">
					<a href="javascript:;">产品特点</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapActions } from "vuex";

export default {
	components: {
		swiper,
		swiperSlide
	},
	data: function() {
		return {
			logoImg: require("../assets/logo_desc.png"),
			titleImg: require("../assets/desc_title.png"),
			title2Img: require("../assets/desc_title_02.png"),
			navBg1Img: require("../assets/index_03_nav_01.png"),
			navBg2Img: require("../assets/index_03_nav_02.png"),
			navBg3Img: require("../assets/index_03_nav_03.png"),
			navBg4Img: require("../assets/index_03_nav_04.png"),
			bodySwiperIndex: 0,
			bodySwiperOption: {
				direction: "horizontal",
				autoplay: "auto",
				loop: false,
				speed: 1000,
				on: {
					slideChangeTransitionEnd: this
						.onBodySlideChangeTransitionEnd
				}
			},
			target_down: 0,
			basic_down: 0
		};
	},
	methods: {
		...mapActions(["getUserInfoDown", "sendUserlog"]),
		onBodySlideChangeTransitionEnd: function() {
			let index = this.$refs.bodySwiper.swiper.activeIndex;
			// console.log(index);
			this.bodySwiperIndex = index;
		},
		onBodySwiperChange: function() {
			// this.$refs.mySwiper.swiper.slideTo(
			// 	this.$refs.bodySwiper.swiper.activeIndex
			// );
		},
		swiperTo: function(index) {
			this.$refs.bodySwiper.swiper.slideTo(index);
		},
		toIndex: function() {
			this.$router.push({ path: "/" });
			this.sendUserlog(["close_desc_page", ""]);
		}
	},
	mounted: function() {
		let _that = this;
		this.getUserInfoDown([
			function(err, data) {
				if (err) {
					return;
				}
				// test
				// data = {
				// 	code: 0,
				// 	msg: "ok",
				// 	data: {
				// 		status: 1,
				// 		tserrno: 0,
				// 		basic_down: 204800,
				// 		basic_up: 30720,
				// 		target_down: 307200,
				// 		target_up: 0,
				// 		account: "",
				// 		addr: "",
				// 		pid: "",
				// 		isp: "",
				// 		city: "",
				// 		province: "",
				// 		country: ""
				// 	}
				// };
				if (data.code === 0) {
					_that.basic_down = data.data.basic_down;
					_that.target_down = data.data.target_down;
				}
			}
		]);
	}
};
</script>

<style lang="less" scoped>
.desc {
	width: 100%;
	height: 100%;
	background-image: url(../assets/desc_bg.jpg);
	background-size: 100% 100%;

	.top {
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
	}

	.top_wrap {
		width: 100%;
		max-width: 1150px;
		height: 100px;
		margin: 0 auto;
	}

	.top_nav_logo {
		display: inline-block;
		vertical-align: top;
		margin-top: 20px;
	}

	.top_wrap .top_nav_wrap {
		margin-top: 30px;
		float: right;
		vertical-align: top;
	}

	.top_nav_wrap a {
		margin-left: 60px;
		color: #999999;
		display: inline-block;
	}

	.top_nav_wrap a.active,
	.top_nav_wrap a:hover {
		color: #ffffff;
	}

	.top_nav_slogan {
		display: inline-block;
		color: #cccccc;
		font-size: 16px;
		font-style: italic;
		margin-top: 35px;
		margin-left: 30px;
	}

	.body_title {
		width: 80%;
		max-width: 886px;
		margin: 0 auto;
		margin-top: 180px;
		margin-bottom: 30px;

		img {
			width: 100%;
		}
	}

	.swiper-slide {
		height: 830px;
	}

	.swiper-slide-1-wrap {
		height: 100%;
		width: 100%;
		max-width: 1250px;
		margin: 0 auto;
		background-image: url(../assets/desc_bg_02.png);
		background-size: 846px 509x;
		background-repeat: no-repeat;
		background-position: right bottom;
		overflow: hidden;
		// padding-bottom: 130px;

		.body_desc {
			width: 80%;
			max-width: 886px;
			margin: 0 auto;
			font-size: 30px;
			color: #dde7ef;
			margin-top: 120px;

			p {
				margin-bottom: 20px;

				span {
					width: 20px;
					display: inline-block;
				}
			}
		}

		.body_btn_wrap {
			width: 80%;
			max-width: 886px;
			margin: 0 auto;
			margin-top: 120px;
			.body_btn {
				color: #ffffff;
				font-size: 32px;
				width: 240px;
				height: 66px;
				line-height: 66px;
				text-align: center;
				background-color: #fbb91f;
				border-radius: 33px;
				display: block;
				cursor: pointer;
			}
		}

		.body_tips_wrap {
			width: 80%;
			max-width: 886px;
			margin: 0 auto;
			margin-top: 26px;
			color: #ffffff;
			font-size: 24px;
			padding-left: 80px;
			font-weight: bolder;
		}
	}

	.body_title_02 {
		width: 50%;
	}

	.swiper-slide-3-wrap {
		width: 100%;
		max-width: 1150px;
		margin: 0 auto;
	}

	.swiper-slide-3-nav {
		font-size: 0;

		.body_btn {
			color: #ffffff;
			font-size: 22px;
			width: 150px;
			height: 46px;
			line-height: 46px;
			text-align: center;
			background-color: #fbb91f;
			border-radius: 25px;
			cursor: pointer;
			margin: 0 auto;
			margin-top: 20px;
			display: block;
		}
	}

	.swiper-slide-3-nav-item {
		width: 23%;
		margin: 0 1%;
		height: 400px;
		display: inline-block;
		background-color: rgba(255, 255, 255, 0.1);
		margin-top: 80px;
		vertical-align: top;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.swiper-slide-3-nav-item-01 {
		background-image: url(../assets/nav_03_bg_01.jpg);
	}

	.swiper-slide-3-nav-item-02 {
		background-image: url(../assets/nav_03_bg_02.jpg);
	}

	.swiper-slide-3-nav-item-03 {
		background-image: url(../assets/nav_03_bg_03.jpg);
	}

	.swiper-slide-3-nav-item-04 {
		background-image: url(../assets/nav_03_bg_04.jpg);
	}

	.swiper-slide-3-nav-item-wrap {
		width: 94%;
		margin: 0 auto;
	}

	.swiper-slide-3-nav-item-icon {
		text-align: center;
		margin-top: 90px;
		margin-bottom: 50px;
	}

	.swiper-slide-3-nav-item-icon img {
		width: 70px;
	}

	.swiper-slide-3-nav-item-hr {
		text-align: center;
		margin-top: 5px;
		margin-bottom: 30px;
		display: none;
	}

	.swiper-slide-3-nav-item-title {
		font-size: 24px;
		color: #ffffff;
		text-align: center;
		margin-bottom: 30px;
		font-weight: bolder;
	}

	.swiper-slide-3-nav-item-desc {
		font-size: 18px;
		color: #ffffff;
		text-align: center;
	}

	.swiper-slide-3-nav-item-desc p {
		line-height: 30px;
	}

	.swiper_page {
		text-align: center;
		margin-top: 30px;

		ul {
			list-style: none;

			li {
				color: #b5b5b5;
				font-size: 20px;
				font-weight: bolder;
				border-bottom: 4px solid #b5b5b5;
				width: 300px;
				display: inline-block;
				text-align: center;
				height: 50px;
				line-height: 50px;
				cursor: pointer;

				a {
					color: #b5b5b5;
				}
			}

			li:hover,
			li.active {
				color: #e1b54f;
				border-bottom: 4px solid #e1b54f;
				a {
					color: #e1b54f;
				}
			}
		}
	}
}
</style>

